import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { config } from '@app/core/app-config';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PropertyOnboardingService {
  constructor(private http: HttpClient) {}

  addPropertyToItem(rulesetId: string, propertyId: string, itemType: string): Observable<boolean> {
    return this.http.post(`${config.API_URL}/${itemType}/${rulesetId}/properties/${propertyId}`, {}).pipe(
      map((res) => {
        return true;
      }),
      catchError((err) => {
        return of(false);
      })
    );
  }

  removePropertyFromItem(rulesetId: string, propertyId: string, itemType: string): Observable<boolean> {
    return this.http.delete(`${config.API_URL}/${itemType}/${rulesetId}/properties/${propertyId}`).pipe(
      map((res) => {
        return true;
      }),
      catchError((err) => {
        return of(false);
      })
    );
  }
}
